export const ESTABLISHMENT_INTERNAL_INVOICE_STATUS_DRAFT = "DRAFT";
export const ESTABLISHMENT_INTERNAL_INVOICE_STATUS_SUBMITTED = "SUBMITTED";
export const ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED = "ACCEPTED";
export const ESTABLISHMENT_INTERNAL_INVOICE_STATUS_REJECTED = "REJECTED";
export const ESTABLISHMENT_INTERNAL_INVOICE_STATUS_CANCELED = "CANCELED";

export const establishmentInternalInvoiceStatuses = [
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_DRAFT,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_SUBMITTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_ACCEPTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_REJECTED,
  ESTABLISHMENT_INTERNAL_INVOICE_STATUS_CANCELED,
];
